//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CRUDGenerico from '../../../../shared-components/generico/CRUDGenerico';
import TipoAcaoLateral from './TipoAcaoLateral';
import TipoAcaoTabela from './TipoAcaoTabela';

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'TipoAcao',
  extends: CRUDGenerico,
  data() {
    return {
      tipoAcaoResources: this.$api.tipoAcao(this.$resource),
      tableHeader: [
        {
          name: this.$t('label.codigo'),
          tooltip: this.$t('label.codigo'),
          sortType: 'idExterno',
          classes: [],
        },
        {
          name: this.$t('label.nome'),
          tooltip: this.$t('label.nome'),
          sortType: 'nome',
          classes: [],
        },
        {
          name: this.$tc('label.tipo_provisao', 1),
          tooltip: this.$tc('label.tipo_provisao', 1),
          sortType: 'tipo',
          classes: [],
        },
      ],
      tableRows: [],
    };
  },
  components: {
    TipoAcaoLateral,
    TipoAcaoTabela,
  },
  computed: {
    ...generateComputed('Tipo Acao', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    alterarTamanhoPagina(valor) {
      this.requestPopular({ size: valor, page: 1 });
    },
    requestAdicionar(objeto, cb = null) {
      this.requestAdicionarGenerico(this.tipoAcaoResources.gravar, objeto, cb);
    },
    requestAtivarInativar(index) {
      const row = this.tableRows[index],
        id = row.id;
      return this.requestAtivarInativarGenerico(row, id, this.tipoAcaoResources);
    },
    requestAtualizar(objeto) {
      this.requestAtualizarGenerico(this.tipoAcaoResources.atualizar, objeto);
    },
    requestExportacao(cb) {
      this.exportar(cb, 'tipo_acao_simples');
    },
    requestPopular(page = null, cb = null) {
      this.requestPopularGenerico(this.tipoAcaoResources.listar, page, cb);
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/tipo-acao/TipoAcao.vue?vue&type=script&lang=js&